import {UIGameGoToPointAnimation} from './UIGameGoToPointAnimation'
import {PIXI} from '@colonist/pixi'
import {FadeAnimationOptions, UIGameFadeAnimation} from './UIGameFadeAnimation'
import {Point} from '@colonist/game-mechanic-validators'

export class UIGameGoToPointFadeAnimation extends UIGameGoToPointAnimation {
    private readonly fadeAnimation: UIGameFadeAnimation
    private readonly options: FadeAnimationOptions

    constructor(viewToAnimate: PIXI.Container, destinationPoint: Point, speed?: number, options?: FadeAnimationOptions) {
        super(viewToAnimate, destinationPoint, speed)
        this.options = options ?? UIGameGoToPointFadeAnimation.getDefaultOptions()
        this.fadeAnimation = new UIGameFadeAnimation(viewToAnimate, undefined, this.options)
    }

    start() {
        this.viewToAnimate.alpha = this.options.initialAlpha
        super.start()
        return this
    }

    onGameTick(deltaTime: number, elapsedMS: number): void {
        super.onGameTick(deltaTime, elapsedMS)
        this.fadeAnimation.updateAnimation(deltaTime, elapsedMS, this.completionPercentage)
    }

    resetToDefaultState(): void {
        this.fadeAnimation.resetToDefaultState()
        super.resetToDefaultState()
    }

    private static getDefaultOptions(): FadeAnimationOptions {
        return {
            initialAlpha: 1,
            fadeSpeed: 0.1,
            completionPercentageToStartFade: 0.1,
            isFadeIn: false,
        }
    }
}
